module.exports = __webpack_public_path__ + "img/nodata.47552655.png";